

if ($("#user-navigation").length && document.location.toString().match('#')) {
    $('#user-navigation .user-nav a[href="#'+document.location.toString().split('#')[1]+'"]').tab('show') ;
}